import React, { useState, useEffect, useRef, useMemo } from 'react'
import styled from 'styled-components';
import logo from '../../images/MegaPlazaBuilding.jpg';
import { delay } from '../../utils/delay';
import { addSection, editSection } from '../../redux/sectionSlice';
import { useDispatch } from 'react-redux';
import { currentDateLocale } from '../../utils/currentDate';
import { useSelector } from 'react-redux';
import { mobile } from '../../responsive';

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url(${logo})
      center;
      
  background-size: cover;
`

const Wrapper = styled.div`
    width: 60vw;
    background-color: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    ${mobile({
        width: '70vw',
    })};
`

const Title = styled.h1`
    text-decoration: underline;
    text-decoration-color: gray;
    text-underline-offset: 6px;
    margin: 5px;
    text-align: center;
`

const SubTitle = styled.h1`
    color: red;
    margin: 5px;
    font-size: 15px;
    
`

const Form = styled.div`
    display: flex;
    flex-direction: column;
`

const FormRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px;

    ${mobile({
        flexWrap: 'wrap',
        justifyContent: 'center',
    })};
`

const FormColumn = styled.div`

`

const FormLabel = styled.h1`
    font-size: 20px;
    font-weight: 300;
    margin: 5px;
    padding: 10px;
    
     ${mobile({
         textAlign: 'center'
     })}
`

const FormInput = styled.input`
    padding: 10px;
    margin: 5px;
    font-size: 20px;
    width: 300px;
    border-radius: 5px;
    border: none;
   
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
     &:hover, &:focus {
         box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                 -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
   
     }
     
    ${mobile({
        width: '60vw'
    })};
`

const Button = styled.button`
    padding: 10px 20px;
    margin: 30px 20px;
    border-radius: 10px;
    color: white;
    background: rgba(0, 200, 200, 0.9);
    cursor: pointer;
    border: none;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
    &:hover{
        box-shadow: none;
    }
`

const FormMessageBox = styled.h1`
    height: 20px;
    font-size: 20px;
    margin: 0;
    visibility: ${props => props?.messageType ? 'visible' : 'hidden'};
    color: ${props => props?.messageType === 1 ? 'green' : 'red'};
`

const Section = ({sectionIdToEdit}) => {

    //console.log(sectionIdToEdit);
    const initialState = {
        'sectionId' : '',
        'sectionName' : '',
        'sectionDesc' : '',
        'sectionHead' : '',
        'updatedDate' : '',
        'createdDate' : ''
    };
    const [section, setSection] = useState(initialState);
    const [formMessage, setFormMessage] = useState({});
    const [edit, setEdit] = useState(false);
    const dispatch = useDispatch();
    const sectionRedux = useSelector(state => state.sectionRedux);
    const formRef = useRef();
    const sections = useMemo(() => [...sectionRedux?.sections], [sectionRedux?.sections]);
    

    const clearState = () => {
        setSection({...initialState});
        setEdit(false);
    };

    useEffect(() => {

        if(sectionIdToEdit && sectionIdToEdit.sectionId && Number(sectionIdToEdit.sectionId) > 0){
            setEdit(true);
            const editDept = sections?.filter((item) => item.sectionId === Number(sectionIdToEdit.sectionId));
            if(editDept && editDept[0]){
                setSection(editDept[0]);
            }
            
        }

        if(formRef.current){
            formRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ sectionIdToEdit]);

    const handleFormInput = (e) => {
        const {name, value} = e.target;
        setSection({...section, [name]: value});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Create Section Clicked');
        if (section?.sectionName && section?.sectionDesc) {
            console.log('No Errors');
            
            if(edit){
                await dispatch(
                    editSection({
                        ...section, 
                        'updatedDate': currentDateLocale(),
                    })
                );
            }
            else{
                await dispatch(
                    addSection({
                        ...section,
                        'sectionId' : getNextAvailableId(), 
                        'createdDate': currentDateLocale(),
                    })
                );
            }
            
            await clearState();
            setFormMessage({'type' : 1, 'message' : 'Section Saved Successfully'});
            //setSection({});

        } 
        else{
            console.log('Has Errors');
            setFormMessage({'type' : 2, 'message' : 'Some required fields are not filled'});
        }

        await delay(5000);

        setFormMessage({});

    }

    const getNextAvailableId = () => {
        return sectionRedux && sectionRedux.sections && sectionRedux.sections.length > 0 
            ? sectionRedux.sections[sectionRedux.sections.length - 1].sectionId + 1 : 1;
    };

    return (
        <Container ref={formRef}>
            <Wrapper>
                <Title>
                    {edit ? 'Edit Section' : 'Create New Section'}
                </Title>
                <SubTitle>
                    * == required
                </SubTitle>
                <FormMessageBox messageType={formMessage?.type}>
                    {formMessage?.message}
                </FormMessageBox>
                <Form>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Section Name*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='sectionName'
                                        placeholder= 'Enter Section Name'
                                        value = {section.sectionName}
                                        onChange = {(e) => handleFormInput(e)} 

                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Section Description*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='sectionDesc'
                                        placeholder='Enter Section Description'
                                        value={section.sectionDesc}
                                        onChange={(e) => handleFormInput(e)}
                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Section Head
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='sectionHead'
                                        placeholder='Enter Section Head'
                                        value={section.sectionHead}
                                        onChange={(e) => handleFormInput(e)} />
                            
                        </FormColumn>
                    </FormRow>
                </Form>
                <Button onClick={(e) => handleSubmit(e)}>
                    {edit ? 'Edit Section' : 'Create Section'}
                </Button>
            </Wrapper>
        </Container>
    )
}

export default Section
